import {ProductData} from "./product-types";
import {BASE_PLANTER} from "./products/base-planter/base-planter";
import {SPIRAL_VASE} from "./products/spiral-vase/spiral-vase";
import pot4 from "../../images/products/doniczka1-4.svg";


export const PRODUCTS: ProductData[] = [
    BASE_PLANTER,
    SPIRAL_VASE,
    {
        id: '3',
        title: 'Rounded Vase',
        state: 'TBA',
        icon: pot4,
        maxElements: 3,
        elements: [],
        disabled: true,
        description: "Stwórz przytulny klimat w swoim domu dzięki naszej doniczce w stylu boho. Wykonana z naturalnych, biodegradowalnych materiałów. Doskonale nadaje się do postawienia na balkonie czy altanie. Delikatne, pastelowe kolory – różowy, miętowy i jasnobeżowy – dodadzą Twojemu wnętrzu subtelnego uroku.",
        images: [
            "https://metcon-uploads.s3.eu-central-1.amazonaws.com/shop/1/1.png",
            "https://metcon-uploads.s3.eu-central-1.amazonaws.com/shop/1/2.png",
            "https://metcon-uploads.s3.eu-central-1.amazonaws.com/shop/1/3.png"
        ],
        details: [
            "Produkt stworzony z materiałów biodegradowalnych.",
            "Doniczki pokryte są warstwą żywicy zapobiegającą przeciekaniu oraz chroniącą przed słońcem.",
            "Tutaj 3 opis."
        ],
        policies: [],
        default: [],
    }
];